<template>
  <div class="content__column content__column--small">
    <h1 class="content__title">Información de la Marca</h1>
    <div class="information" v-if="brand">
      <p v-if="brand.name" class="information__text"><strong class="information__text--strong">Marca: </strong>{{brand.name}}</p>
      <p v-if="status" class="information__text"><strong class="information__text--strong">Estatus: </strong>{{status}}</p>
    </div>
  </div>
</template>

<script>
import {brandStatus} from './mocks'
import {config} from '@/core/config/base'
export default {
  props: {
    brand: {
      type: Object
    }
  },
  computed: {
    status: function () {
      let status = brandStatus.filter(element => element.id === this.brand.status_id)
      return status[0].name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/designers/view.vue